import cloneReduxUtil from '../../../../redux/utils/clone'
import getUpdatedDataReduxUtil from '../../../../redux/utils/get-updated-data'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import {
  SET_DATA_KEY,
  WORKOUT_EXERCISE_KEY
} from '../../constants'
import { omitObjectUtil } from 'packages/src'

export function cloneWorkoutExerciseDataUtil (workoutExercise) {
  const newSetData = getValueReduxUtil(
    workoutExercise,
    WORKOUT_EXERCISE_KEY.SET_DATA
  )
    .map(set => omitObjectUtil(set, [SET_DATA_KEY.TIME_ELAPSED]))

  return getUpdatedDataReduxUtil(cloneReduxUtil({
    instance: workoutExercise,
    updates: {
      [WORKOUT_EXERCISE_KEY.SET_DATA]: newSetData
    }
  }))
}
